import { t } from 'ember-intl';
import Svg from 'tio-employee/components/svg';
import TioFooter from 'tio-common/components/tio/footer';
import Button from 'tio-ui/components/button';
import transitionTo from 'ember-router-helpers/helpers/transition-to';

<template>
  <div class="tio-col-flush min-h-screen tio-bg-sunken">
    <main class="tio-place-center grow px-4 py-10">
      <section class="w-full max-w-screen-sm tio-bg-surface shadow-md rounded-md p-8 text-center">
        <p class="mb-3 tio-text-lg-semibold">{{t "logged_out.thank_you"}}</p>
        <p class="mb-6 tio-fg-muted">{{t "logged_out.success"}}</p>
        <Button {{on "click" (transitionTo "login")}} @intent="primary" class="w-full sm:w-auto">
          {{t "logged_out.sign_in_button"}}
        </Button>
      </section>

      <div class="mt-10 max-w-md w-full tio-flex-center">
        <Svg @name="growth" role="img" aria-label={{t "svg.growth"}} class="w-full h-auto" />
      </div>
    </main>
    <TioFooter />
  </div>
</template>
